import React from 'react';
import './arrows.scss';
import ArrowLeft from '../../atoms/static-icons/arrow-left';
import ArrowRight from '../../atoms/static-icons/arrow-right';

const PrevArrow = ({
  slideCount,
  currentSlide,
  handleClick,
  onClick,
  ...props
}) => (
  <button
    {...props}
    aria-label='precedente'
    onClick={(e) => {
      onClick && onClick(e);
      handleClick && handleClick(e);
    }}
  >
    <ArrowLeft />
  </button>
);

const NextArrow = ({
  slideCount,
  currentSlide,
  handleClick,
  onClick,
  ...props
}) => (
  <button
    {...props}
    aria-label='successivo'
    onClick={(e) => {
      onClick && onClick(e);
      handleClick && handleClick(e);
    }}
  >
    <ArrowRight />
  </button>
);

export { PrevArrow, NextArrow };
